import PropTypes from 'prop-types'
import React from 'react'
import {
    Dialog,
    MemberName,
} from 'react-wot-bootstrap'

import {
    DIALOG_CHANGE_COMMANDER_TITLE,
    DIALOG_CHANGE_COMMANDER_CONTENT,
    DIALOG_CHANGE_COMMANDER_SUBMIT_BUTTON_CAPTION,
    DIALOG_BUTTON_CANCEL_CAPTION,
} from './translations'

const propTypes = {
    selectedMemberName: PropTypes.string.isRequired,

    isOpened: PropTypes.bool,

    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

const ChangeCommanderDialog = (props) => {
    const member = (<MemberName name={props.selectedMemberName} />)
    const dialogContent = (
        <div>
            {DIALOG_CHANGE_COMMANDER_CONTENT}
            &ensp;
            {member}
        </div>
    )
    return (
        <Dialog
            title={DIALOG_CHANGE_COMMANDER_TITLE}
            submitCaption={DIALOG_CHANGE_COMMANDER_SUBMIT_BUTTON_CAPTION}
            closeCaption={DIALOG_BUTTON_CANCEL_CAPTION}
            isOpened={props.isOpened}
            isFocusOnSubmitBtn
            onSubmit={props.onSubmit}
            onClose={props.onClose}
        >
            {dialogContent}
        </Dialog>
    )
}

ChangeCommanderDialog.propTypes = propTypes

export default ChangeCommanderDialog



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Dialogs/ChangeCommander.js